import { useQuery } from "@tanstack/react-query";
import { fetchSubmittedPlaylistCountsByShow } from "@src/apis/showApis";
import { QUERY_KEYS } from "@src/queries/queryKeys";

interface UseSubmittedPlaylistCountsResult {
  submittedByShow: Record<string, number>;
  loadingSubmittedCounts: boolean;
}

export const useSubmittedPlaylistCounts =
  (): UseSubmittedPlaylistCountsResult => {
    const { data, isLoading } = useQuery({
      queryKey: [QUERY_KEYS.SUBMITTED_PLAYLIST_COUNT, "byShow"],
      queryFn: fetchSubmittedPlaylistCountsByShow,
      staleTime: 5 * 60 * 1000,
    });

    return {
      submittedByShow: data ?? {},
      loadingSubmittedCounts: isLoading,
    };
  };
